import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TrustSignals = () => {
  const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Business Consultant",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_16e75c406-1763294340369.png",
    avatarAlt: "Professional headshot of blonde woman in navy blazer with warm smile",
    content: "AuthorPreneur AI helped me publish my first book in just 3 weeks. The AI agents guided me through every step, and now I'm getting speaking invitations!",
    rating: 5
  },
  {
    id: 2,
    name: "Marcus Johnson",
    role: "Tech Entrepreneur",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f23d9c3d-1763295425663.png",
    avatarAlt: "Professional headshot of African American man in gray suit with confident expression",
    content: "As a busy founder, I didn't have time for traditional writing. This platform made it possible to share my expertise and build credibility in my industry.",
    rating: 5
  },
  {
    id: 3,
    name: "Emily Chen",
    role: "Marketing Director",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_13e02ac36-1763298775843.png",
    avatarAlt: "Professional headshot of Asian woman in white blouse with friendly smile",
    content: "The AI captured my writing voice perfectly. My book looks professionally published, and the Skool community support has been invaluable.",
    rating: 5
  }];


  const securityFeatures = [
  { icon: 'Shield', text: 'SSL Encrypted' },
  { icon: 'Lock', text: 'Secure Payments' },
  { icon: 'CheckCircle', text: 'PCI Compliant' },
  { icon: 'Award', text: 'Trusted by 10,000+ Authors' }];


  return (
    <div className="space-y-8">
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
          Trusted by Entrepreneurs Worldwide
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {securityFeatures?.map((feature, index) =>
          <div key={index} className="flex flex-col items-center text-center space-y-2">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                <Icon name={feature?.icon} size={24} className="text-primary" />
              </div>
              <span className="text-xs font-medium text-foreground">{feature?.text}</span>
            </div>
          )}
        </div>
      </div>
      <div className="space-y-4">
        <h3 className="text-lg font-heading font-semibold text-foreground">
          What Our Authors Say
        </h3>
        <div className="grid md:grid-cols-3 gap-4">
          {testimonials?.map((testimonial) =>
          <div
            key={testimonial?.id}
            className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-shadow duration-200">

              <div className="flex items-center space-x-3 mb-3">
                <Image
                src={testimonial?.avatar}
                alt={testimonial?.avatarAlt}
                className="w-12 h-12 rounded-full object-cover" />

                <div>
                  <p className="text-sm font-medium text-foreground">{testimonial?.name}</p>
                  <p className="text-xs text-muted-foreground">{testimonial?.role}</p>
                </div>
              </div>
              <div className="flex items-center space-x-1 mb-2">
                {[...Array(testimonial?.rating)]?.map((_, i) =>
              <Icon key={i} name="Star" size={14} className="text-accent fill-accent" />
              )}
              </div>
              <p className="text-xs text-foreground leading-relaxed">{testimonial?.content}</p>
            </div>
          )}
        </div>
      </div>
    </div>);

};

export default TrustSignals;